import { Component, Input } from '@angular/core'
import { Tone } from 'src/app/domain/status'

/** Square-dot status chip. sm = 24px list chip, md = 32px editor box, on="dark" for dark headers. */
@Component({
  selector: 'rt-status',
  template: `<span class="rt-status rt-status--{{ size }} rt-status--on-{{ on }} rt-tone-{{ def.tone }}">{{ def.label }}</span>`,
})
export class RtStatusComponent {
  @Input() def: { readonly label: string; readonly tone: Tone } = { label: '', tone: 'muted' }
  @Input() size: 'sm' | 'md' = 'sm'
  @Input() on: 'light' | 'dark' = 'light'
}
